import {ModalParagraph} from '@/components/ui/modal-atoms/ModalAtoms'
import styled, {css} from 'styled-components'

export const StyledAccessProfileConfirmationModalParagraph = styled(ModalParagraph)(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['500']};

        & > b {
            font-weight: 400;
            color: ${palette.neutral['950']};
        }
    `
)
